import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { verifyEmail } from 'api';
import { Title, Button, Text } from 'ui';
import queryString from 'query-string';
import logo from '../assets/logo-white.png'

export default function EmailVerified(props) {

  const location = useLocation();
  const [error, setError] = useState("");
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    const {oobCode} = queryString.parse(location.search);
    verifyEmail(oobCode)
      .then(res => {
        setVerified(true);
      })
      .catch(error => {
        console.log('error', error);
        setError(error.message || "Something went wring. Please try again.");
      });
  }, [location.search])

  return (
    <div className="auth auth-login">
      <div className="auth-sidebar">
        <div className="auth-logo">
          <img src={logo} alt="Taptivate"/>
        </div>
        <Title white className="auth-title">
          {verified ? "Your email has been verified" : "Verifying..."}
        </Title>
        {error &&
          <div style={{paddingBottom:16}}>
            <Text white>{error}</Text>
          </div>
        }
        {verified &&
          <div>
            <div style={{paddingBottom:16}}>
              <Text white>You can now sign in with your new account.</Text>
            </div>
            <Button className="auth-button" white label="Sign In" to="login"/>
          </div>
        }
      </div>
    </div>
  );
}